import React, { useRef, useState } from "react";
import { Grid } from "@mui/material";
import { CircularIndeterminate, FormButton, SpinnerOverlay } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { LARGO, mensajeLargo } from "consts/limites-campos";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  snackbarData,
  userCredentials,
} from "recoilState/GlobalState";
import styles from "styles/pages/ModalActions.module.scss";
import { RNHUnidadUpd } from "services/services-mia/programa-salud/estructuras/RNHUnidadUpd";
import PermisosDeReparticion, {
  permisosDesdeRow,
} from "../../components/PermisosDeReparticion";

// Mismo form que el Insert (nombre/cod/desc + Departamento + División), precargado
// con los datos de la unidad seleccionada.
export default function UpdateModal({ updateList, row, closeModal, departamentos = [], loadingDptos = false, divisiones = [], loadingDivisiones = false }) {
  const setSnackBarInfo = useSetRecoilState(snackbarData);
  const credentials = useRecoilValue(userCredentials);
  const formikRef = useRef();
  const [inRequest, setInRequest] = useState(false);

;

  const handleSubmit = async (values) => {
    const response = await RNHUnidadUpd(credentials, {
      id: row.id,
      name: values.nombre,
      cod: values.cod,
      desc: values.desc,
      departamentoId: values.departamentoId,
      divisionId: values.divisionId,
      admiteRotativos: values.admiteRotativos,
      admiteGuardias: values.admiteGuardias,
      version: row.version,
    });
    if (response.ok) {
      setSnackBarInfo({
        message: "Unidad modificada correctamente",
        severity: "success",
        open: true,
      });
      formikRef.current.resetForm();
      updateList();
      closeModal();
    }
  };


  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
          nombre: row.name ?? "",
          cod: row.cod ?? "",
          desc: row.desc ?? "",
          departamentoId: row.dptoId ?? "",
          divisionId: row.divisionId ?? "",
          ...permisosDesdeRow(row),
      }}
      validationSchema={
        yup.object({
          nombre: yup.string("Debe ingresar un nombre").max(LARGO.nombre, mensajeLargo(LARGO.nombre)).required("Debe ingresar un nombre"),
          cod: yup.string("Debe ingresar un código").max(LARGO.cod, mensajeLargo(LARGO.cod)).required("Debe ingresar un código"),
          desc: yup.string("Debe ingresar una descripción").max(LARGO.desc, mensajeLargo(LARGO.desc)).required("Debe ingresar una descripción"),
        })
      }
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form className={styles.inputs} noValidate>
          <div className={styles["column"]}>
            <Grid
              container
              rowSpacing={0}
              columnSpacing={2}
              sx={{
                width: "100%",
                "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
              }}
            >
              <Grid item xs={4}>
                <FormikTextInput
                  fullWidth={true}
                  name="cod"
                  labelText="Código"
                    inputProps={{ maxLength: LARGO.cod }}
                />
              </Grid>
              <Grid item xs={8}>
                <FormikTextInput
                  fullWidth={true}
                  name="nombre"
                  labelText="Nombre"
                    inputProps={{ maxLength: LARGO.nombre }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormikTextInput
                  fullWidth={true}
                  name="desc"
                  labelText="Descripción"
                  multiline
                    inputProps={{ maxLength: LARGO.desc }}
                />
              </Grid>
              <Grid item xs={6}>
                <FormikSelectInput
                  fullWidth={true}
                  name="departamentoId"
                  labelText="Departamento"
                  disabled={loadingDptos}
                  onChange={(e) => {
                    setFieldValue("departamentoId", e.target.value);
                    // Al cambiar de departamento reseteamos la división para no dejar una combinación inválida.
                    setFieldValue("divisionId", "");
                  }}
                >
                  <option value={""}>
                    {loadingDptos ? "Cargando departamentos..." : "Sin asignar"}
                  </option>
                  {departamentos.map(({ id, name }) => (
                    <option key={id} data-id={id} value={id}>
                      {name}
                    </option>
                  ))}
                </FormikSelectInput>
              </Grid>
              <Grid item xs={6}>
                <FormikSelectInput
                  fullWidth={true}
                  name="divisionId"
                  labelText="División"
                  disabled={loadingDivisiones || !values.departamentoId}
                >
                  <option value={""}>
                    {!values.departamentoId
                      ? "Seleccione un departamento primero"
                      : loadingDivisiones ? "Cargando divisiones..." : "Sin asignar"}
                  </option>
                  {divisiones
                    .filter((d) => String(d.dptoId) === String(values.departamentoId))
                    .map(({ id, name }) => (
                      <option key={id} data-id={id} value={id}>
                        {name}
                      </option>
                    ))}
                </FormikSelectInput>
              </Grid>
              <Grid item xs={12}>
                <PermisosDeReparticion />
              </Grid>
            </Grid>
            <FormButton
              inRequest={inRequest}
              newFormData={{ button: "Modificar" }}
              onCloseModal={closeModal}
            />
            {inRequest && <SpinnerOverlay />}
          </div>
        </Form>
      )}
    </Formik>
  );
}
